import { useTranslation } from 'react-i18next';

import { Div, Seo } from 'ui';
import { useQueryString } from 'hooks';

import { Hero } from './Hero';
import Doubts from './Doubts';
import HowToGetFlixx from './HowToGetFlixx';


const Index = () => {

  const { t } = useTranslation()
  const { from } = useQueryString()

  const paddingTop = from === 'webview' ? 0 : 70

  return (
    <Div
      width='100%'
      overflow='hidden'
      display='flex'
      flexDirection='column'
      alignItems='center'
      paddingTop={paddingTop}
      transform='translateY(-70px)'
    >
      <Seo
        title={t('seoFlixxTitle')}
        description={t('seoFlixxDescription')}
      />

      <Hero />
      <HowToGetFlixx />
      <Doubts />
    </Div>
  )
}

export default Index
